define('controllers/admin/authentication/authenticationController',[
    "application",
    "jquery",
    "angular",
    "config",
    "moment",
    "underscore",
    "toastr",
    "postaljs",
    "application"
],
    function (app, $, angular, config, moment, _, toastr, postal) {
        "use strict";
        return app.controllers.controller("Authentication", ["$scope", "$window", function ($scope, $window) {

            $scope.isBusy = false;

            $scope.data = {
                login: "",
                password: "",
                remember: false
            };

            var csrf = null;
            $scope.init = function (cfcsrf) {
                csrf = cfcsrf;
            };

            $scope.submit = function () {
                $scope.isBusy = true;

                return $.post(config.admin.authentication.login, {
                    login: $scope.data.login,
                    password: $scope.data.password,
                    remember: $scope.data.remember,
                    cfcsrf: csrf
                })
                    .fail(function (xhr) {

                        $scope.$apply(function () {
                            $scope.isBusy = false;
                        });

                        if (xhr.status === 401)
                            toastr.error("Login or password is incorrect.");
                        else
                            toastr.error("Unable to login. Try again later.");
                    })
                    .success(function () {
                        location.href = config.admin.home;
                    });

            };

        }
        ]);

    });
